import React from "react";


const ShowURLField = ({publication, editPublication}) => {
    const setCheckboxDisabledValue = () => {
        if (publication && publication.publication_url) {
            return false
        } else {
            return true
        }
    }

    return (
        <tr>
            <td>
                <strong>
                    Show URL on Website?
                </strong>
            </td>
                <td>
                    <input
                        type="checkbox"
                        disabled={setCheckboxDisabledValue()}
                        checked={publication.show_url_on_website}
                        style={{marginLeft: "10px", cursor: "pointer"}}
                        onChange={() => editPublication("show_url_on_website", !publication.show_url_on_website)}
                    />
            </td>
        </tr>
    )
}

export default ShowURLField


// WEBPACK FOOTER //
// ./src/routes/publications/components/ShowURLField.js